import React, { useEffect, useState } from 'react';
import axios from 'axios'
import {getCookie} from '../../common/utils/auth'
import { message, Spin, Form, Input, Button, Select, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { config } from "enviroment.js"
import "antd/dist/antd.css";
import './Admin.scss';
import AdminPageHeader from './AdminPageHeader'


const UserDetailView = (props) => {
  const [loading, setLoading] = useState({ status: true, type: 'page' })
  const [error, setError] = useState({ status: false })
  const [stores, setStores] = useState([])
  const [btnLoading, setBtnLoading] = useState(false)
  const [form] = Form.useForm()

  useEffect(() => {
    if (props?.match?.params?.id) {
      axios.get(config.raUrl + `/admin/users/${props.match.params.id}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookie('token')}`
        }
      })
        .then((res) => {
          let user = res.data.user
          user.stores = JSON.parse(user.stores)
          setStores(res.data.stores)
          form.setFieldsValue(user)
          setLoading({ status: false })
        }).catch((err) => {
          console.log("error caught: ", err.response)
          let errorMessage = {
            status: true,
            text: 'Ooops!',
            sub: 'Something went wrong.'
          }
          if (err.response.status === 401) {
            errorMessage.text = 'Unauthorized'
            errorMessage.sub = 'You are not authorized to view this page.'
          }
          setError(errorMessage)
          setLoading({ status: false })
        })
    }
  }, [props?.match?.params?.id, form])

  const handleSubmit = (values) => {
    setBtnLoading(true)
    values.stores = JSON.stringify(values.stores)
    axios.put(config.raUrl + `/admin/users/${props.match.params.id}`, values, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getCookie('token')}`
      }
    })
      .then((res) => {
        message.success('User updated!');
      }).catch((err) => {
        console.log("error caught: ", err)
        message.error('Something went wrong!');
      }).finally(
        setBtnLoading(false)
      )
  }

  const showConfirm = () => {
    Modal.confirm({
      title: 'Are you sure?',
      icon: <ExclamationCircleOutlined />,
      content: 'Once this user is deleted you cannot recover it.',
      onOk() {
        axios.delete(config.raUrl + `/admin/users/${props.match.params.id}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getCookie('token')}`
          }
        })
          .then((res) => {
            props.history.replace({ pathname: '/admin/users' })
            message.success('User deleted!');
          }).catch((err) => {
            console.log("error caught: ", err)
            message.error('Something went wrong!');
          })
      },
    });
  }

  return (
    <Spin spinning={loading.status} size="large" className={loading.status && loading.type}>
      {error.status
        ? (
          <>
          <div className="error-container">
            <div className="error-text">{error.text}</div>
            <div className="error-sub">{error.sub}</div>
          </div>
          </>
        ) : (
          <>
          <AdminPageHeader
            onBack={() => { window.location.href = '/admin/users/' }}
            title="Edit User"
            extra={
              [<Button key="1" danger onClick={showConfirm}>Delete User</Button>]
            }
          />
          <div className="userFormContainer">
            <Form
              layout="vertical"
              form={form}
              // initialValues={formValues}
              onFinish={handleSubmit}
            >
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item label="First Name" name="first_name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item label="Last Name" name="last_name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item label="Email" name="email" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="role" label="Role" rules={[{ required: true }]}>
                <Select >
                  <Select.Option value="staff">Staff</Select.Option>
                  <Select.Option value="admin">Admin</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item name="stores" label="Stores" rules={[{ required: true }]}>
                <Select
                  mode="multiple"
                >
                  <Select.Option value="all">All Stores</Select.Option>
                  {stores.map(store => (
                    <Select.Option key={store.store_id} value={store.store_id}>{store.title}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item >
                <Button className="user-form-btn" type="primary" htmlType="submit" loading={btnLoading}>Submit</Button>
              </Form.Item>
            </Form>
          </div>
          </>
        )
      }
    </Spin>
  )
}
export default UserDetailView;
